<template>
  <div class="role">
    <div class="topNav">
      <div><ShowNavHead/></div>
    </div>
    <div class="roleCon">
      <div class="rolemain">
        <div class="roleLeft">
          <div class="roleLeftTitle">角色</div>
          <!-- <div class="roleAdmin">管理员</div> -->
          <div class="roles" v-for="(role,index) in roles" :key="index" v-bind:class="{roleselected:isActive==index}"
            @click="checkItem(role.rolename,role.roletype,index)">{{role.rolename}}</div>
          <!-- <div class="addRole">+ 新增角色</div> -->
        </div>
        <div class="roleRight">
          <div class="btn-box">
            <el-button class="search" size="mini" @click="updateChange">保存</el-button>
          </div>
          <div class="mkItem" v-for="(item,index) in roleDtlList" :key="index">
            <div class="mkItemTop">
              <div class="mkItemTitle">{{item.powername}}</div>
              <el-switch v-model="item.isused" active-color="#19BD92" active-value="1" inactive-value="0" @change="switchChange(item,item.isused)"></el-switch>
            </div>
            <!-- 我的模块禁止点击 -->
            <div class="roleCheckItem" v-show="item.children&&item.children.length>0">
              <el-checkbox-group v-model="checkedList" @change="checkChange(item,checkedList,item.isused)">
                <el-checkbox v-for="(items,index) in item.children" :label="items.powercode" :key="index">{{items.powername}}</el-checkbox>
              </el-checkbox-group>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
export default {
  name: "role",
  data() {
    return {
      role:"",
      isActive:0,
      //所有角色
      roles: [],
      roletype:'',
      listLoading:false,
      //角色对应详情数据
      // roleDtlList:[],
      roleDtlList : [],
      //选中的页面
      checkedList: [],
      switchValue:'',
      checkList: [""]
    };
  },
  created() {
      this.getAllRole();
  },
  methods: {
    //获取所有角色
    getAllRole(){
      this.listLoading = true;
      xz.bGetPowerList().then(res => {
        // console.log('所有角色',res)
        this.listLoading = false;
        this.roles = res.msg
        this.roletype = res.msg[0].roletype;
        this.getRoleDtl(this.roletype)
      });
    },
    //获取角色所有权限详情 1 勾选 0 未勾选
    async getRoleDtl(roletype){
      this.listLoading = true;
      this.checkedList=[]
      xz.getRoleInfo(roletype).then(res => {
        // console.log('权限详情',res)
        this.roleDtlList = res.msg.parent
        for (let index = 0; index < this.roleDtlList.length; index++) {
          let roleCheckList = []
          const childrens = this.roleDtlList[index].children;
          if(this.roleDtlList[index].isused=='1'){
            this.checkedList.push(this.roleDtlList[index].powercode)
          }
          for (let i = 0; i < childrens.length; i++) {
            if(childrens[i].isused=='1'){
              roleCheckList.push(childrens[i].powercode)
              this.checkedList.push(childrens[i].powercode)
            }
          }
          //判断是否全选中（开关开启/关闭）
          if(roleCheckList.length == childrens.length){
            this.roleDtlList[index].isused = '1'
            if(this.roleDtlList[index].isused=='1'){
            this.checkedList.push(this.roleDtlList[index].powercode)
          }
          }
          //判断有选中但未全选中（父级code也要加上）
          if(0<roleCheckList.length && roleCheckList.length<childrens.length){
            this.checkedList.push(this.roleDtlList[index].powercode)
          }
        }
        // console.log('checkedList',this.checkedList)
        this.listLoading = false;
      }).catch(err=>{
        console.log("err",err)
      })
    },
    //页面复选框
    checkChange(item,value){
      // console.log('fuxuan',this.checkedList)
      let allList = [] //选中的页面复选框
      for (let index = 0; index < item.children.length; index++) {
        let roleChild = item.children[index];
        //判断复选框是否选中 未选中为0 选中为1
        if(value.indexOf(roleChild.powercode) == -1){
            item.isused = '0'
            roleChild.isused = '0'
        }else{
          roleChild.isused = '1'
          allList.push(roleChild.powercode)
        }
      }
      //所在复选框都没选中 开关关闭
      if(allList==[]||allList.length<=0){
        let currindex = this.checkedList.indexOf(item.powercode)
        if(currindex >-1){
          this.checkedList.splice(currindex,1)
        }
      }else{
        //若选中了则父级的powercode 子级也要加上去
        this.checkedList.push(item.powercode)
        //数组合并
        this.checkedList.push.apply(this.checkedList,allList)
      }
      //都选中的话 开关开启
      if(allList.length == item.children.length){
        item.isused = '1'
      }else{
        item.isused = '0'
      }
      //去重
      this.checkedList = [...new Set(this.checkedList)];
      // console.log('fuxuan',item)
      // console.log('ss' ,this.checkedList)
    },
    //开关
    switchChange(item,parentIsUse){
      //  console.log('parentIsUse',parentIsUse)
        if(parentIsUse == '1'){ // 是全部打开
            this.checkedList.push(item.powercode);
            for(let index=0; index<item.children.length;index++){
              item.children[index].isused = item.isused
              if(this.checkedList.indexOf(item.children[index].powercode)==-1){
                this.checkedList.push(item.children[index].powercode)
              }
            }
        }else{
          let indexs = this.checkedList.indexOf(item.powercode)
          this.checkedList.splice(indexs,1);
          for(let index=0; index<item.children.length;index++){
            item.children[index].isused = item.isused
            let itemindex = this.checkedList.indexOf(item.children[index].powercode)
            if(itemindex >-1){
                this.checkedList.splice(itemindex,1)
            }
          }
        }
        // console.log('parentIsUse',this.checkedList)
    },
    //保存修改
    updateChange(){
       //去重
      this.checkedList = [...new Set(this.checkedList)];
      this.$confirm('此操作将修改角色权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        // console.log('提交',this.checkedList)
        xz.bSaveRoletypeInfo(this.roletype,this.checkedList.toString()).then(res => {
          // console.log('保存修改',res)
          if(res.status == 'ok'){
            this.$message({ type: 'success', message: '修改成功' })
            this.getRoleDtl(this.roletype)
          }
        }).catch(err=>{
          console.log("err",err)
        })
      })
    },
    checkItem(rolename,roletype,index) {
      // console.log('rol',rolename,roletype)
      this.isActive = index;
      this.role = rolename;
      this.roletype = roletype;
      this.getRoleDtl(roletype)
    }
  }
};
</script>

<style >
.role .search {
    /* height: 32px;
    margin-right: 10px;
    border-radius: 5px; */
    background-color: #ebfaf5!important;
    border: 1px solid #62d2b4!important;
    color: #19BD92!important;
    margin-right: 10px!important;
}
.btn-box{
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  margin-top: 15px;
}
.roleCheckItem .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #19BD92;
  /* margin-bottom: 15px; */
}
.roleCheckItem .el-checkbox__input.is-disabled+span.el-checkbox__label{
  margin-bottom: 15px;
}
.roleCheckItem .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #19BD92;
    border-color: #19BD92;
}
.roleCheckItem .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color:#19BD92 ;
}
.roleCheckItem .el-checkbox__label{
  min-width: 108px;
}
.el-checkbox__inner .el-checkbox{
  width: 160px;
  height: 30px;
  line-height: 30px;
}
.roleCheckItem .el-checkbox{
  margin-bottom: 15px;
}
</style>